import { render, staticRenderFns } from "./ShowName.vue?vue&type=template&id=32759694"
import script from "./ShowName.vue?vue&type=script&lang=js"
export * from "./ShowName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports